import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Contact from "./Contact";
import Whatsapp from "./util/Whatsapp";
import Perguntas from "./Perguntas";
import { Faixa, Cabecalho } from "./Faixa";
import { Destaque, Itens, OutrosServicos, LinkSeta, fundosDosBlocos } from "./Blocos";
import { whatsappUrl } from "./util/whatsappUrl";
import { trackWhatsapp } from "./util/analytics";
import { cidadesVizinhas, listar } from "./data/cidades";
import imagem1 from "../assets/1.webp";
import imagem3 from "../assets/3.webp";
import imagem4 from "../assets/4.webp";

const imagens = {
  "/desenvolvimento-de-software": imagem4,
  "/automacao-de-processos": imagem3,
  "/diagnostico-de-processos": imagem1,
};

const ServicePage = ({ servico }) => {
  useEffect(() => {
    const anterior = document.title;
    document.title = servico.titulo;
    return () => {
      document.title = anterior;
    };
  }, [servico.titulo]);

  const blocos = [
    ...servico.secoes.map((secao) => ({ chave: secao.titulo, rotulo: secao.rotulo, titulo: secao.titulo, texto: secao.texto, azul: Boolean(secao.numerada), conteudo: <Itens secao={secao} claro={Boolean(secao.numerada)} /> })),
    { chave: "perguntas", rotulo: "Dúvidas", titulo: "Perguntas frequentes", conteudo: <Perguntas perguntas={servico.perguntas} /> },
    {
      chave: "regiao",
      rotulo: "Atendimento",
      titulo: "Onde atendemos",
      conteudo: (
        <div className="xl:text-center">
          <p className="text-xl leading-relaxed text-gray-700 xl:w-2/3 xl:mx-auto">
            {`Atendimento presencial em Orleans e em cidades do sul de Santa Catarina, como ${listar(cidadesVizinhas)}. Desenvolvimento, implantação e suporte com acompanhamento à distância, para empresas de toda Santa Catarina.`}
          </p>
          <LinkSeta href="/onde-atendemos">Ver o mapa das cidades atendidas</LinkSeta>
        </div>
      ),
    },
    { chave: "outros", rotulo: "Serviços", titulo: "O que mais fazemos", conteudo: <OutrosServicos atual={servico.slug} /> },
  ];
  const fundos = fundosDosBlocos(blocos);
  const fundoFinal = fundos[fundos.length - 1];

  return (
    <>
      <Header />
      <main>
        <div className="bg-pattern-gradient pt-12 xl:pb-32">
          <div className="text-white w-3/4 mx-auto">
            <div className="grid xl:grid-cols-[2fr_3fr] xl:items-center xl:pt-48 pt-24 pb-16">
              <div className="xl:col-start-2 xl:row-start-1 xl:self-end z-10 min-w-0">
                <h1 className="text-4xl sm:text-5xl xl:text-6xl font-semibold leading-[1.1] mb-8 break-words hyphens-auto">
                  <Destaque texto={servico.h1} destaque={servico.destaque} />
                </h1>
              </div>

              <div className="xl:col-start-1 xl:row-start-1 xl:row-span-2 xl:self-center z-10 mb-8 xl:mb-0 flex justify-center">
                <img src={imagens[servico.slug]} alt={servico.imagemAlt} width="500" height="500" fetchpriority="high" className="h-auto w-60 xl:w-96 aspect-square" />
              </div>

              <div className="xl:col-start-2 xl:row-start-2 xl:self-start z-10 min-w-0">
                <p className="text-xl xl:text-2xl leading-relaxed mb-10">{servico.subtitulo}</p>
                <a
                  href={whatsappUrl(servico.mensagem)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackWhatsapp(`pagina${servico.slug.replace(/\//g, "-")}`)}
                  className="btn-glass font-semibold py-6 px-8 rounded-full w-full xl:w-auto xl:min-w-[66.666%] whitespace-nowrap block xl:inline-block text-xl text-center"
                >
                  {servico.cta}
                </a>
              </div>
            </div>
          </div>
        </div>

        {blocos.map((bloco, indice) => (
          <Faixa key={bloco.chave} fundo={fundos[indice]} anterior={indice === 0 ? "white" : fundos[indice - 1]} proximo={fundos[indice + 1] || "contato"}>
            <Cabecalho rotulo={bloco.rotulo} titulo={bloco.titulo} texto={bloco.texto} claro={bloco.azul} />
            {bloco.conteudo}
          </Faixa>
        ))}
      </main>
      <Contact fundoAnterior={fundoFinal} />
      <Whatsapp />
      <Footer />
    </>
  );
};

export default ServicePage;
